import React, { FC } from 'react';
import {useNavigate} from 'react-router-dom';
import cnBind from 'classnames/bind';
import {GxIcon, GxPhoneInput, GxTextarea} from '@garpix/garpix-web-components-react';
import {useStoreon} from 'storeon/react';
import 'react-responsive-modal/styles.css';
import dayjs from 'dayjs';
import styles from './styles/index.module.scss';
import Input from '../../../../../components/Input';
import {AnketaIcon, MailIcon, PhoneIcon, PlusIcon, UserIcon} from '../../../../../assets';
import {useSiteConfigurations} from '../../../../Applications/hooks';
import {TYPE_TASK} from '../../../const';
import {MODALS_NAMES} from '../../../../../const/modals';
import useModal from '../../../../../hooks/useModal';
import ModalSendMessage from '../../../../Applications/components/ModalSendMessage';
import useModalFlag from '../../../../../hooks/useModalFlag';


interface IModalChangeTaskBody {
    currentTask: any,
}
const cn = cnBind.bind(styles);
const ModalChangeTaskBody: FC<IModalChangeTaskBody> = (
    {
        currentTask,
    }) => {
    const navigate = useNavigate();
    const siteConfig = useSiteConfigurations();
    const {openModal} = useModal();
    const {dispatch} = useStoreon()
    const { flag: FlagMessage, setModalFlag: setModalMessage } = useModalFlag()

    const openModalUserEdit = (id?: number): void => {
        openModal(MODALS_NAMES.modalUser, {isEdit: true, userId: id})
    }

    const openModalUser = (): void => {
        openModal(MODALS_NAMES.modalUser, {isEdit: false})
    }
     const openModalCall = (phone: string): void => {
        dispatch('modalCall/show', true)
        dispatch('modalCall/setInfo', {
            type: 'DEFAULT',
            phone: `+${phone}`
        });
    }

    return (
        <>
            <div className={styles['body']}>
                <div className={styles['form']}>
                    <div className={styles['form-item']}>
                        <div className={styles['form-item__group']}>
                            <label className={styles['form-item--label']} htmlFor="customer">
                                Исполнитель:
                            </label>
                            <Input value={currentTask.fio} disabled className={styles['form-item--input']} />
                        </div>
                    </div>
                    <div className={cn(styles['form-item'], styles['form-item__wrapper'])}>
                        <div className={cn(styles['form-item__group'], styles['form-item__group--left-block'])}>
                            <label className={styles['form-item--label']} style={{whiteSpace: 'nowrap'}} htmlFor="customer">
                                Тип задачи:
                            </label>
                            <Input value={TYPE_TASK[currentTask.source].label} disabled className={cn(styles['form-item--input'], styles['type-task'])} />
                        </div>
                            <div className={cn(styles['form-item__group'], styles['form-item__group--right-block'])}>
                                <label className={cn(styles['form-item--label'], styles['type-task--label'])} htmlFor="customer">
                                    Срок:
                                </label>
                                <Input value={currentTask.deadline_at ? dayjs(currentTask.deadline_at).format('YYYY.MM.DD HH:mm') : '-'} disabled className={styles['form-item--input']} />
                            </div>
                    </div>
                    <div className={styles['form-item']}>
                        <div className={styles['form-item__group']}>
                            <label className={styles['form-item--label']} htmlFor="customer">
                                Название:
                            </label>
                            <Input value={currentTask.title} disabled className={styles['form-item--input']} />
                        </div>
                    </div>
                    <div className={styles['form-item']}>
                        <div className={styles['form-item__group']}>
                            <label className={styles['form-item--label']} htmlFor="customer">
                                Заявка:
                            </label>
                            <Input value={currentTask.order} disabled className={cn(styles['form-item--input'], styles['medium'])} />
                        </div>
                        <button
                            disabled={!currentTask.order}
                            type='button'
                            className={styles['btn']}
                            onClick={()=>navigate(`${siteConfig.page_sportsman_schedule  }?order=${currentTask.order}`)}>
                            <GxIcon className={styles['btn--icon']} src={AnketaIcon}/>
                        </button>
                    </div>
                    <div className={styles['form-item']}>
                        <div className={styles['form-item__group']}>
                            <label className={styles['form-item--label']} htmlFor="customer">
                                Описание:
                            </label>
                            <GxTextarea resize='none' value={currentTask.description} disabled className={styles['form-item--input']} />
                        </div>
                    </div>
                    <div className={styles['form-item']}>
                        <div className={styles['form-item__group']}>
                            <label className={styles['form-item--label']} htmlFor="customer">
                                ФИО:
                            </label>
                            <Input value={currentTask.client_name} disabled className={cn(styles['form-item--input'], styles['medium'])} />
                        </div>
                        <button onClick={()=> {
                            if(!currentTask.client){
                                openModalUser();
                            }else{
                                openModalUserEdit(currentTask.client)
                            }
                        }} type='button' className={styles['btn']}>
                            <GxIcon className={styles['btn--icon']} src={!currentTask.client ? PlusIcon : UserIcon}/>
                        </button>
                    </div>
                    <div className={styles['form-item']}>
                        <div className={styles['form-item__group']}>
                            <label className={styles['form-item--label']} htmlFor="customer">
                                Телефон:
                            </label>
                            <GxPhoneInput
                                value={currentTask.phone}
                                country='ru'
                                className={cn(styles['form-item--input'], styles['phone'])}
                                disabled
                            />
                        </div>
                        <button disabled={!currentTask.phone} onClick={()=>openModalCall(currentTask.phone)} type='button' className={styles['btn']}>
                            <GxIcon className={styles['btn--icon']} src={PhoneIcon}/>
                        </button>
                    </div>
                    <div className={styles['form-item']}>
                        <div className={styles['form-item__group']}>
                            <label className={styles['form-item--label']} htmlFor="customer">
                                Email:
                            </label>
                            <div  className={cn(styles['email'])} >
                                <a href={`mailto:${currentTask.email}`}> {currentTask.email}</a>
                            </div>
                        </div>
                        <button  disabled={!currentTask.email} type='button' className={styles['btn']} onClick={setModalMessage}>
                            <GxIcon className={styles['btn--icon']} src={MailIcon}/>
                        </button>
                    </div>
                </div>
            </div>
            {FlagMessage &&
            <ModalSendMessage user={{
                username: currentTask.client_name,
                email: currentTask.email
            }} taskId={currentTask.id} flag={FlagMessage} onRequestClose={setModalMessage} />}
        </>
    )
}

export default ModalChangeTaskBody;